import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=9696d20a&"
import script from "./index copy 2.vue?vue&type=script&lang=js&"
export * from "./index copy 2.vue?vue&type=script&lang=js&"
import style0 from "./index copy 2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports